var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"czIcon",attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24","aria-hidden":"true"}},[_c('path',{attrs:{"d":_vm.path}})])}
var staticRenderFns = []

export { render, staticRenderFns }